import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup as HeroRadioGroup } from '@heroui/react';
export const RadioGroup = ({ color = 'primary', size = 'md', orientation = 'vertical', className, children, ...props }) => {
    return (_jsx(HeroRadioGroup, { color: color, size: size, orientation: orientation, className: className, ...props, children: children }));
};
//# sourceMappingURL=RadioGroup.js.map